import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from 'recharts';

const BacklinkDistributionByDAChart = ({ data }) => {
  // Group backlinks into DA ranges
  const daRanges = {
    '0-20': 0,
    '21-40': 0,
    '41-60': 0,
    '61-80': 0,
    '81-100': 0
  };

  // Assuming each entry has a backlink count of 1 for simplicity
  data.forEach((item) => {
    const da = parseInt(item.da, 10);
    if (da <= 20 || item.da == 'NA') {
      daRanges['0-20'] += 1;
    } else if (da <= 40) {
      daRanges['21-40'] += 1;
    } else if (da <= 60) {
      daRanges['41-60'] += 1;
    } else if (da <= 80) {
      daRanges['61-80'] += 1;
    } else {
      daRanges['81-100'] += 1;
    }
  });

  const chartData = Object.keys(daRanges).map(range => ({
    range,
    backlinks: daRanges[range]
  }));

  return (
    <BarChart width={600} height={150} data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="range" />
      <YAxis />
      <Tooltip />
      {/* <Legend /> */}
      <Bar dataKey="backlinks" fill="var(--bl-color)" />
    </BarChart>
  );
};

export default BacklinkDistributionByDAChart;
